export const SEARCH_PARAM_PACKAGE_KEY = 'pckg';
export const SEARCH_PARAM_PACKAGE_ADD_CREDITS = 'addCredits';
